<template>
    <AppLayoutBase>
        <template slot="drawer">
            <AppLayoutNavbarDrawer>
                <template slot="list">
                    <SettingsLayoutDrawer/>
                </template>
            </AppLayoutNavbarDrawer>
        </template>

        <template slot="main">
            <SettingsUsersCreateContent/>
        </template>
    </AppLayoutBase>
</template>

<script>
    export default {
        name: "SettingsUsersCreate"
    }
</script>

<style scoped>

</style>